import { FetchResponseError } from "app/services/fetchService";

const BAD_REQUEST_STATUS = 400;

/**
 * A 400 on delete is a validation response rather than a fault: the profile is still referenced (e.g.
 * "Employee profile is used by a playbook."). The endpoint sends that reason as a bare JSON string, so the
 * parsed body is the message itself. DELETE surfaces the untouched `FetchResponseError`, hence the body is
 * still readable here.
 */
export const getDeleteProfileErrorMessage = async (error: unknown): Promise<string | undefined> => {
    if (!(error instanceof FetchResponseError) || error.response?.status !== BAD_REQUEST_STATUS) {
        return undefined;
    }

    try {
        const body: unknown = await error.response.clone().json();

        return typeof body === "string" && body.trim() ? body.trim() : undefined;
    } catch {
        return undefined;
    }
};
